export enum eDeedDocumentType {
  limitedWarrantyDeed = 'limited_warranty_deed',
  quitclaimDeed = 'quitclaim_deed',
  specialWarrantyDeed = 'special_warranty_deed',
  warrantyDeed = 'warranty_deed',
  other = 'other',
}

export const DeedDocumentTypeLabels = {
  [eDeedDocumentType.limitedWarrantyDeed]: 'Limited Warranty Deed',
  [eDeedDocumentType.quitclaimDeed]: 'Quitclaim Deed',
  [eDeedDocumentType.specialWarrantyDeed]: 'Special Warranty Deed',
  [eDeedDocumentType.warrantyDeed]: 'Warranty Deed',
  [eDeedDocumentType.other]: 'Other',
};
